import { connect } from "react-redux";

var ReactionFeedback = require("components/support/ReactionFeedback");
var ScoringData = require("components/writing/evaluations/ScoringData");
var RubricItemOverride = require("components/writing/evaluations/RubricItemOverride")
var TextAreaMarkups = require("components/writing/evaluations/TextAreaMarkups");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");

var Spinner = require("components/utility/Spinner");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");

var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

require("writing/answers/answer_scoring_details.scss");

@connect(
	(state, props) => ({
		evaluation: WritingSelectors.evaluation({ state, id: props.answer.evaluation })
	}),
	(dispatch, props) => ({
	})
)
class AnswerScoringDetails extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			markupKey: null
		};
	}

	onModeChange(controlMode) {
		if (this.props.onModeChange) {
			this.props.onModeChange(controlMode)
		}
	}

	answerDetails() {
		if (this.props.answer && this.props.evaluation) {
			return this.props.evaluation.autograder_data;
		}
	}

	selectMarkup(markupKey) {
		this.setState({ markupKey })
	}

	currentMarkupKey() {
		if (this.state.markupKey) {
			return this.state.markupKey;
		}

		var leaves = this.leaves();
		if (leaves) {
			return _.keys(leaves)[0];
		}
	}

	leaves() {
		var answerDetails = this.answerDetails();
		if (answerDetails) {
			return AutograderDisplayConfig.getRubricLeaves(answerDetails.polarizing, false);
		}
	}

	activeTagging() {
		var leaves = this.leaves();
		var markupKey = this.currentMarkupKey();

		if (leaves && leaves[markupKey]) {
			var activeTags = {}
			_.each(leaves[markupKey].tags, (tag) => {
				if (activeTags[tag.key] == undefined) {
					activeTags[tag.key] = []
				}
				activeTags[tag.key].push(tag)
			})

			_.each(activeTags, (tags, key) => {
				if (!AutograderDisplayConfig.isDisplayTag(key)) {
					delete activeTags[key];
				}
			});

			_.each(activeTags, (tags, key) => {
				if (AutograderDisplayConfig.shouldGroupTagSpans(key)) {
					_.each(tags, (tag, t) => {
						activeTags[key][t].spans = AutograderDisplayConfig.groupTagSpans(tag)
					})
				}
			})

			return activeTags;
		} else {
			return {};
		}
	}

	renderScoringData() {
		var answerDetails = this.answerDetails();
		var scoringDetails = _.pick(answerDetails, "filtering", "warning", "evaluating");
		var activeTagging = this.activeTagging();
		var tagColors = pickTagColors(activeTagging);

		if (this.props.editMode) {
			var scoringData = (
				<RubricItemOverride leaves={this.leaves()} evaluation={this.props.evaluation} />
			)
		} else {
			var scoringData = (
				<ScoringData onModeChange={this.onModeChange} markupKey={this.currentMarkupKey()}
					tagging={activeTagging} leaves={this.leaves()} tagColors={tagColors}
					selectMarkup={this.selectMarkup} {...scoringDetails} />
			)
		}

		return (
			<div>
				<div className="answerText">
					<TextAreaMarkups text={answerDetails.corrected_answer}
						tagging={activeTagging} tagColors={tagColors} />
				</div>
				{scoringData}
			</div>
		)

	}

	render() {
		var originalAnswer = this.props.answer;
		var answerDetails = this.answerDetails();
		if (!originalAnswer) {
			var displayContent = (
				<Spinner placeholder />
			);

		} else if (!answerDetails) {
			if (originalAnswer.body != undefined) {
				var answerText = originalAnswer.body
			} else {
				var answerText = <MultiPartAnswerDisplay parts={ originalAnswer.parts } breakSections />
			}
			if ("evaluation_details" in this.props.answer) {
				var status = (
					<p className="text-center">
						Scoring details are unvailable for this answer.
					</p>
				)
			} else {
				var status = <Spinner placeholder />
			}
			var displayContent = (
				<div>
					<p className="answerText">
						{ answerText }
					</p>
					{ status }
				</div>
			)

		} else if (!answerDetails.corrected_answer) {
			var displayContent = (
				<div>
					<p className="answerText">
						{ originalAnswer.body }
					</p>
					<i>Our scoring algorithm has changed since this answer was scored. Please contact
					{ " " }<a href="mailto:support@whooosreading.org">support@whooosreading.org</a>
					{ " " }if you would like us to re-score this answer.</i>
				</div>
			)

		} else {
			var displayContent = this.renderScoringData(answerDetails)
		}

		return (
			<div className="answerScoringDetails">
				{ displayContent }
			</div>
		);
	}
}

function pickTagColors(tagging) {
	var tagToColors = {};
	_.each(_.sortBy(_.keys(tagging)), (key, index) => {
		var hasSpans = _.any(tagging[key], (tag) => "spans" in tag);
		if (hasSpans) {
			tagToColors[key] = AUTOGRADER_COLOR_LIST[index % AUTOGRADER_COLOR_LIST.length]			
		}
	})

	return tagToColors;
}

var AUTOGRADER_COLOR_LIST = ["#96dafe", "#a0e881", "#ffcbb3", "#cfadec", "#f2de7f",
	"#c8ecff", "#c0f2aa", "#faaf88", "#fff864"]

AnswerScoringDetails.WrappedComponent.propTypes = StrictPropTypes({


	// Inserted by @connect
	evaluation: PropTypes.object,
	
	answer: PropTypes.object,
	editMode: PropTypes.bool,
	onModeChange: PropTypes.func,

});

module.exports = AnswerScoringDetails;


// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerScoringDetails.js